<template>
    <div>
        <div class="page-btns-box" v-if="$utils.have('/message/notify/send')">
            <el-button  type="primary"  size="small" @click="$refs.add.show()">发送短信通知</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="通知ID"></el-table-column>
                <el-table-column prop="type" label="通知类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 0">疫情防控提示</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="通知名称" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="objectId" label="演出ID"></el-table-column>
                <el-table-column prop="num" label="通知人数"></el-table-column>
                <el-table-column prop="createUserName" label="通知人"></el-table-column>
                <el-table-column prop="createTime" label="通知时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$refs.detail.show(scope.row.id)"
                            >详情</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <add ref="add" @onUpdate="getDataList()"></add>
        <detail ref="detail"></detail>
    </div>
</template>

<script>
import Add from './components/add.vue'
import Detail from './components/detail.vue'
const defaultParams = {
    pageNo:1,
}
export default {
    components:{Add,Detail},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            listLoading: false,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/message/notify/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>